/* eslint-disable no-useless-escape */
/* eslint-disable array-callback-return */
/* eslint-disable no-empty */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import {
  MdOutlineFilterAlt,
  MdLocationOn,
  MdClose,
  MdOutlineCreate,
  MdWhatsapp,
  MdOutlineMail,
  MdOutlineArrowBack,
  MdOutlineShare,
} from 'react-icons/md';
import { FaHotel } from 'react-icons/fa';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';
import { Col, Row } from 'react-bootstrap';
import {
  DATE_MONTH_VIEW_FORMAT,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  NAVIGATION_ROUTES,
  checkValidMobileNumber,
} from '../../../shared/constants/Constants';
import {
  formatDate,
  serialize,
  isMobileWidth,
  scrollToTop,
  hideHeaderFooterInMobile,
  showHeaderFooterInMobile,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';
import NoSearchResults from '../../one-way/NoSearchResults';
import './HotelSearchResults.scss';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppIconButton from '../../../shared/components/app-icon-button/AppIconButton';
import AppSidebar from '../../../shared/components/app-sidebar/AppSidebar';
import HotelFilter from './HotelFilters';
import {
  searchHotelsApi,
  getConversionRate,
  emailHotelOptions,
  searchHotelsByNameApi,
  searchMoreHotelsApi,
  searchHotelsV2Api,
} from '../../../api/hotelApi';
import AppButton from '../../../shared/components/app-button/AppButton';
import HotelSearch from '../hotel-search/HotelSearch';
import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import { debounce } from '../../../api/apiUtils';
import HotelListCard from './HotelListCard';
import AppModal from '../../../shared/components/app-modal/AppModal';
import AppLink from '../../../shared/components/app-link/AppLink';
import StarRating from './StarRating';
import HotelMapView from './HotelMapView';
import HotelEmailContent from './HotelEmailContent';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import { getUserDetails } from '../../../api/profileApi';
import { emailFlightOptions } from '../../../api/flightApi';
import AppNumberInput from '../../../shared/components/app-number-input/AppNumberInput';
import HotelEmailShareModal from './HotelEmailShareModal';
import HotelWhatsAppShareModal from './HotelWhatsAppShareModal';
import HotelMapOldView from './HotelMapOldView';
import HotelCardV2 from './HotelCardV2';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import AppPreviewLoader from '../../../shared/components/app-preview-loader/AppPreviewLoader';

const DEBOUNCE_DELAY = 500;

function HotelSearchResults() {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [isLoading, setLoading] = useState(false);
  const [isPreviewLoading, setPreviewLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [searchParams] = useSearchParams();
  const [searchRequest, setSearchRequest] = useState(undefined);
  const [searchResults, setSearchResults] = useState([]);
  const [isSearchDone, setSearchDone] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);
  const [isModifySearch, setIsModifySearch] = useState(false);
  const [currencyOption, setCurrencyOption] = useState(appConfig?.appCurrency);
  const [showInvoiceFare, setShowInvoiceFare] = useState(false);
  const [minHotelFare, setMinHotelFare] = useState(0);
  const [maxHotelFare, setMaxHotelFare] = useState(0);
  const [conversionRate, setConversionRate] = useState(1);
  const allSearchResultsRef = useRef([]);
  const [selectedFilters, setSelectedFilters] = useState({
    selectedMinPrice: minHotelFare,
    selectedMaxPrice: maxHotelFare,
    hotelName: '',
    hotelAddress: '',
    selectedRating: [],
    selectedAmenities: [],
    selectedFacilities: [],
    selectedPropertyTypes: [],
  });
  const [gridView, setGridView] = useState(true);
  const [mapView, setMapView] = useState(false);
  const [shortListedHotels, setShortListedHotels] = useState([]);
  const [showCompareModal, setShowCompareModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [amenitiesList, setAmenitiesList] = useState([]);
  const [requestedDataKey, setRequestedDataKey] = useState('');
  const [page, setPage] = useState(0);
  const [hotelNames, setHotelNames] = useState([]);
  const [hotelLocations, setHotelLocations] = useState([]);
  const [hotelCount, setHotelCount] = useState(0);
  const [starCount, setStarCount] = useState(undefined);
  const hotelModifyRef = useRef(null);
  const [hotelModifyDivHeight, setHotelModifyDivHeight] = useState(0);
  const [doPaginationSearch, setDoPaginationSearch] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingMoreHotels, setIsLoadingMoreHotels] = useState(false);
  const [showShareOptions, setShowShareOptions] = useState(false);
  const [searchResponseId, setSearchResponseId] = useState('');
  const [actualResults, setActualResults] = useState(undefined);
  const [facilities, setFacilities] = useState([]);
  const [visibleHotels, setVisibleHotels] = useState([]);
  const pollAbortRef = useRef(false);
  const [searchProgress, setSearchProgress] = useState(0);
  const searchProgressRef = useRef(0);
  const [propertyTypes, setpropertyTypes] = useState([]);
  const [isCacheLoading, setIsCacheLoading] = useState(false);
  const selectedFiltersRef = useRef({
    selectedMinPrice: 0,
    selectedMaxPrice: 0,
    hotelName: '',
    hotelAddress: '',
    selectedRating: [],
    selectedAmenities: [],
    selectedFacilities: [],
    selectedPropertyTypes: [],
  });
  const sortOptionRef = useRef('');
  const [abortController, setAbortController] = useState(new AbortController());

  const applyFilters = (hotels, filters) => {
    if (!filters) return hotels;
    const hasActiveFilters =
      filters.selectedRating?.length > 0 ||
      filters.hotelName !== '' ||
      filters.hotelAddress !== '' ||
      filters.selectedFacilities?.length > 0 ||
      filters.selectedPropertyTypes?.length > 0 ||
      filters.selectedMaxPrice > 0;
    if (!hasActiveFilters) return hotels;

    return hotels.filter((hotel) => {
      const amenitiesFlag =
        filters.selectedFacilities?.length > 0
          ? filters.selectedFacilities.every((facility) => {
              const facilityUpper = facility.toUpperCase();
              return hotel.fcList.some(
                (fc) =>
                  fc.toUpperCase() === facilityUpper ||
                  fc.toUpperCase().includes(facilityUpper) ||
                  facilityUpper.includes(fc.toUpperCase()),
              );
            })
          : true;
      const isRatingMatch =
        filters.selectedRating?.length > 0
          ? filters.selectedRating.includes(hotel.starRating.toString())
          : true;
      const isNameMatch =
        filters.hotelName !== ''
          ? hotel.propertyName
              ?.toLowerCase()
              ?.indexOf(filters.hotelName.toLowerCase()) > -1
          : true;
      const isAddressMatch =
        filters.hotelAddress !== ''
          ? hotel.shortaddr
              ?.toLowerCase()
              .indexOf(filters.hotelAddress.toLowerCase()) > -1
          : true;
      const isPriceMatch =
        filters.selectedMaxPrice > 0
          ? hotel.minPrice >= filters.selectedMinPrice &&
            hotel.minPrice <= filters.selectedMaxPrice
          : true;
      const propertyTypeFlag =
        filters.selectedPropertyTypes?.length > 0
          ? filters.selectedPropertyTypes.some((pt) =>
              hotel.propertyType.toLowerCase().includes(pt.toLowerCase()),
            )
          : true;
      return (
        isRatingMatch &&
        isNameMatch &&
        isAddressMatch &&
        isPriceMatch &&
        amenitiesFlag &&
        propertyTypeFlag
      );
    });
  };

  const applySort = (hotels, sortOption) => {
    const list = [...hotels];
    if (sortOption === 'priceAsc') {
      list.sort((a, b) => a.minPrice - b.minPrice);
    } else if (sortOption === 'priceDec') {
      list.sort((a, b) => b.minPrice - a.minPrice);
    } else if (sortOption === 'starsAsc') {
      list.sort((a, b) => a.starRating - b.starRating);
    } else if (sortOption === 'starsDec') {
      list.sort((a, b) => b.starRating - a.starRating);
    } else if (sortOption === 'bestRated') {
      list.sort((a, b) => {
        const starDiff =
          parseInt(b.starRating, 10) - parseInt(a.starRating, 10);
        if (starDiff !== 0) return starDiff;
        return a.minPrice - b.minPrice;
      });
    } else {
      list.sort((a, b) => b.starRating - a.starRating);
    }
    return list;
  };

  const isLocalityDestinationSearch = (destinationType) => {
    const mainArray = [
      'locality',
      'sublocality',
      'administrative_area_level_1',
    ];
    const destTypes = Array.isArray(destinationType)
      ? destinationType
      : String(destinationType || '')
          .replace(/[\[\]]/g, '')
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean);

    return destTypes.some((item) => mainArray.includes(item));
  };

  useEffect(() => {
    hideHeaderFooterInMobile();
    return () => showHeaderFooterInMobile();
  }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const entry of entries) {
        if (entry.target === hotelModifyRef.current) {
          setHotelModifyDivHeight(entry.contentRect.height);
        }
      }
    });
    if (hotelModifyRef.current) {
      resizeObserver.observe(hotelModifyRef.current);
    }
    return () => {
      if (hotelModifyRef.current) {
        resizeObserver.unobserve(hotelModifyRef.current);
      }
    };
  }, [searchRequest]);

  const resetSearchResults = () => {
    setPage(0);
    pollAbortRef.current = true;
    setDoPaginationSearch(false);
    setSearchResults([]);
    setSearchDone(false);
    setIsModifySearch(false);
    setCurrencyOption(appConfig?.appCurrency);
    setMinHotelFare(0);
    setMaxHotelFare(0);
    setConversionRate(1);
    const clearedFilters = {
      selectedMinPrice: 0,
      selectedMaxPrice: 0,
      hotelName: '',
      hotelAddress: '',
      selectedRating: [],
      selectedAmenities: [],
      selectedFacilities: [],
      selectedPropertyTypes: [],
    };
    selectedFiltersRef.current = clearedFilters;
    setSelectedFilters(clearedFilters);
    sortOptionRef.current = '';
    setGridView(true);
    setShortListedHotels([]);
    allSearchResultsRef.current = [];
    setSearchRequest(undefined);
    setHotelNames([]);
    setHotelLocations([]);
    setIsCacheLoading(false);
  };

  // console.log('pages:', page, 'total Pages:', totalPages, doPaginationSearch);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollY } = window;
      const pageHeight =
        document.documentElement.scrollHeight - window.innerHeight - 100;
      if (scrollY >= pageHeight) {
        if (!doPaginationSearch) {
          setDoPaginationSearch(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const updateProgress = (value) => {
    searchProgressRef.current = value;
    setSearchProgress(value);
  };

  const appendFacilities = async (propertyList) => {
    let allFacilities = [];
    const hotels = [...propertyList];
    hotels.forEach((hotel) => {
      hotel.fcList.forEach((facility) => {
        allFacilities.push(facility);
      });
    });
    allFacilities = [...new Set(allFacilities)];
    setFacilities(allFacilities);
  };

  const getPolledResults = async (mergedSearchObj, responseId, signal) => {
    if (pollAbortRef.current) return;
    setIsCacheLoading(true);
    const req = {
      ...mergedSearchObj,
      searchRequestId: responseId,
      clientId: '',
    };
    const response = await searchMoreHotelsApi(req, signal);
    if (pollAbortRef.current) return;

    if (response?.propertyList?.length > 0) {
      const propertyList = Array.isArray(response.propertyList)
        ? response.propertyList
        : [response.propertyList];

      const hotelNameList = [];
      const hotelAddressList = [];
      const propertyTypeList = [];
      propertyList.forEach((hotel) => {
        if (!hotelAddressList.some((x) => x.value === hotel.shortaddr)) {
          hotelAddressList.push({
            label: hotel.shortaddr,
            value: hotel.shortaddr,
          });
        }
        if (!hotelNameList.some((x) => x.value === hotel.propertyName)) {
          hotelNameList.push({
            label: `${hotel.propertyName} (${hotel.starRating} star)`,
            value: hotel.propertyName,
            address: hotel.shortaddr,
          });
        }
        if (!propertyTypeList.includes(hotel.propertyType)) {
          propertyTypeList.push(hotel.propertyType);
        }
      });

      allSearchResultsRef.current = propertyList;
      setStarCount(response.stars);
      setHotelNames(hotelNameList);
      setHotelLocations(hotelAddressList);
      setMinHotelFare(response.minprice);
      setMaxHotelFare(response.maxPrice);
      setSearchResponseId(response.serachResponseId);
      setpropertyTypes(propertyTypeList);
      setActualResults(propertyList);
      appendFacilities(propertyList);

      // Re-apply current user filters and sort — don't override user's choices
      const mainArray = [
        'locality',
        'sublocality',
        'administrative_area_level_1',
      ];
      const destTypes = Array.isArray(mergedSearchObj.destinationType)
        ? mergedSearchObj.destinationType
        : String(mergedSearchObj.destinationType)
            ?.replace(/[\[\]]/g, '')
            ?.split(',');
      const hasElement = destTypes.some((item) => mainArray.includes(item));
      const filtered = applyFilters(propertyList, selectedFiltersRef.current);
      let sorted;
      if (!hasElement) {
        filtered.sort((a, b) => a.distance - b.distance);
        sorted = [...filtered];
      } else {
        sorted = applySort(filtered, sortOptionRef.current);
      }
      setSearchResults(sorted);
      setHotelCount(filtered.length);

      if (response.isSearchCompleted === false) {
        // Halve remaining: 50→75→87→94→97… asymptotes to 100 without reaching it
        const remaining = 100 - searchProgressRef.current;
        updateProgress(Math.round(searchProgressRef.current + remaining / 2));
        const nextResponseId = response.serachResponseId || responseId;
        setTimeout(() => {
          getPolledResults(mergedSearchObj, nextResponseId, signal);
        }, 2000);
      } else {
        updateProgress(100);
        setTimeout(() => updateProgress(0), 800);
        setIsCacheLoading(false);
      }
    } else {
      updateProgress(100);
      setTimeout(() => updateProgress(0), 800);
      setIsCacheLoading(false);
    }
  };

  const getHotelSearchResults = async (mergedSearchObj, signal) => {
    pollAbortRef.current = false;
    // setLoading(true);
    const response = await searchHotelsV2Api(mergedSearchObj, signal);

    if (response?.propertyList?.length > 0) {
      const propertyList = Array.isArray(response.propertyList)
        ? response.propertyList
        : [response.propertyList];

      const hotelNameList = [];
      const hotelAddressList = [];
      const propertyTypeList = [];
      propertyList.forEach((hotel) => {
        if (!hotelAddressList.some((x) => x.value === hotel.shortaddr)) {
          hotelAddressList.push({
            label: hotel.shortaddr,
            value: hotel.shortaddr,
          });
        }
        if (!hotelNameList.some((x) => x.value === hotel.propertyName)) {
          hotelNameList.push({
            label: `${hotel.propertyName} (${hotel.starRating} star)`,
            value: hotel.propertyName,
            address: hotel.shortaddr,
          });
        }
        if (!propertyTypeList.includes(hotel.propertyType)) {
          propertyTypeList.push(hotel.propertyType);
        }
      });

      allSearchResultsRef.current = propertyList;
      setStarCount(response.stars);
      setHotelCount(propertyList.length);
      setHotelNames(hotelNameList);
      setHotelLocations(hotelAddressList);
      setMinHotelFare(response.minprice);
      setMaxHotelFare(response.maxPrice);
      setSearchResponseId(response.serachResponseId);
      setpropertyTypes(propertyTypeList);
      setActualResults(propertyList);
      appendFacilities(propertyList);

      // Default sort on first load
      const mainArray = [
        'locality',
        'sublocality',
        'administrative_area_level_1',
      ];
      const destTypes = Array.isArray(mergedSearchObj.destinationType)
        ? mergedSearchObj.destinationType
        : String(mergedSearchObj.destinationType)
            ?.replace(/[\[\]]/g, '')
            ?.split(',');
      const hasElement = destTypes?.some((item) => mainArray.includes(item));
      sortOptionRef.current = 'priceAsc';
      let sorted;
      if (!hasElement) {
        propertyList.sort((a, b) => a.distance - b.distance);
        sorted = [...propertyList];
      } else {
        sorted = applySort(propertyList, 'priceAsc');
      }
      setSearchResults(sorted);

      if (response.isSearchCompleted === false) {
        updateProgress(50);
        setTimeout(() => {
          getPolledResults(mergedSearchObj, response.serachResponseId, signal);
        }, 2000);
      } else {
        updateProgress(100);
        setTimeout(() => updateProgress(0), 800);
      }
    } else {
      setSearchResults([]);
      setAlert({
        variant: 'error',
        title: 'Hotel Search',
        description: response?.statusmessage || 'No Hotels Found',
      });
    }
    setSearchDone(true);
    setPreviewLoading(false);
    setIsModifySearch(false);
  };

  useEffect(() => {
    setAbortController(new AbortController());
    if (searchParams) {
      if (isLoadingMoreHotels) {
        setAlert({
          variant: 'error',
          title: 'Hotel Search',
          description: 'Loading More Hotels please wait',
        });
        return;
      }
      const currentParams = Object.fromEntries([...searchParams]);
      const dict = Object.keys(currentParams)
        .filter((d) => d.startsWith('roomRequirements'))
        .reduce((acc, d) => {
          const textAfterReplace = d.replaceAll(']', '');
          const arr = textAfterReplace.split('[');
          const index = arr[1];
          const name = arr[2];
          if (acc[index] == null) acc[index] = {};
          acc[index][name] = currentParams[d];
          delete currentParams[d];
          return acc;
        }, {});
      let typez = [];
      Object.keys(currentParams).forEach((x) => {
        if (x.startsWith('destinationType[')) {
          typez.push(currentParams[x]);
          delete currentParams[x];
        } else if (
          !isEmpty(currentParams.destinationType) &&
          typeof currentParams.destinationType === 'string' &&
          currentParams.destinationType.indexOf('[') === -1
        ) {
          typez = currentParams.destinationType.split(',');
        }
      });
      const roomRequirements = Object.keys(dict).map((d) => dict[d]);
      const destinationType = typez;
      resetSearchResults();
      const req = {
        searchQuery: {
          checkIn: '',
          checkInSearch: '',
          checkOut: '',
          checkOutSearch: '',
          city: '',
          country: '',
          totRoomNights: 1,
          loggedInUserAgentId: '',
          customerCountry: '',
          paxCOR: '',
          isAminity: true,
          baseCurrency: appConfig?.appCurrency,
          totrooms: 1,
          totalPeople: 1,
          roomRequirements: [
            {
              adults: '1',
              childs: '0',
              childAges: '',
              infants: '0',
              infantAges: '',
            },
          ],
        },
        pagination: {
          currentPage: 0,
          pageSize: 20,
          stars: '',
          sortBy: '',
          version: 'v2',
          minPrice: 0,
          propertyType: '',
          isPostpaid: '',
          maxPrice: 1000000,
        },
        cache: 6,
        searchV3: 'false',
        profileId: '',
        isSBT: '',
        destinationType: currentParams.destinationType,
        destinationId: currentParams.destinationId,
      };
      delete currentParams.destinationType;
      const mergedSearchObj = {
        ...req,
        searchQuery: {
          ...req.searchQuery,
          ...currentParams,
          roomRequirements,
        },
        pagination: {
          ...req.pagination,
          ...currentParams.pagination,
        },
        hotelwise: 'false',
        destinationType: destinationType,
      };
      const controller = abortController;
      const { signal } = controller;
      setSearchRequest({ ...mergedSearchObj });
      setPreviewLoading(true);
      getHotelSearchResults(mergedSearchObj, signal);
    }
    return () => {
      if (abortController) {
        abortController.abort();
      }
    };
  }, [searchParams]);

  const handleSort = (option) => {
    sortOptionRef.current = option;
    const sorted = applySort(searchResults, option);
    setSearchResults(sorted);
  };

  const handleShowFilters = () => {
    setOpenFilters(true);
  };
  const onRoomChoose = (hotelData) => {
    const request = {
      searchResponseId: searchResponseId,
      pbKey: '',
      hotelCode: hotelData.propertyCode,
      isMapped: hotelData.mapped,
      mappingSupplier: hotelData.mappingProvider,
      contentFilter: 'none',
      clientId: '',
      checkIn: searchRequest.searchQuery.checkIn,
      checkInSearch: searchRequest.searchQuery.checkInSearch,
      checkOutSearch: searchRequest.searchQuery.checkOutSearch,
      checkOut: searchRequest.searchQuery.checkOut,
      city: searchRequest.searchQuery.city,
      country: searchRequest.searchQuery.country,
      faresource: hotelData.fareSource,
      totrooms: searchRequest.searchQuery.totrooms,
      totalPeople: searchRequest.searchQuery.totalPeople,
      roomRequirements: searchRequest.searchQuery.roomRequirements,
    };
    const reqString = JSON.stringify(request);
    window.open(
      `/hotel/details?detailsObj=${encodeURIComponent(reqString)}`,
      '_blank',
    );
  };
  const applyFilterTimerRef = useRef(null);
  const handleApplyFilter = (filters) => {
    if (applyFilterTimerRef.current) clearTimeout(applyFilterTimerRef.current);
    applyFilterTimerRef.current = setTimeout(() => {
      selectedFiltersRef.current = filters;
      setSelectedFilters(filters);
      setAlert(undefined);
      const filtered = applyFilters(actualResults || [], filters);
      const shouldSort =
        isLocalityDestinationSearch(searchRequest?.destinationType) &&
        sortOptionRef.current;
      const sorted = shouldSort
        ? applySort(filtered, sortOptionRef.current)
        : filtered;
      setSearchResults(sorted);
      setHotelCount(filtered.length);
    }, DEBOUNCE_DELAY);
  };

  const handleapplyClearFilter = () => {
    const cleared = {
      selectedMinPrice: minHotelFare,
      selectedMaxPrice: maxHotelFare,
      hotelName: '',
      hotelAddress: '',
      selectedRating: [],
      selectedFacilities: [],
      selectedPropertyTypes: [],
    };
    selectedFiltersRef.current = cleared;
    setSelectedFilters(cleared);
    const shouldSort =
      isLocalityDestinationSearch(searchRequest?.destinationType) &&
      sortOptionRef.current;
    const sorted = shouldSort
      ? applySort(actualResults || [], sortOptionRef.current)
      : actualResults || [];
    setSearchResults(sorted);
    setHotelCount((actualResults || []).length);
  };

  const handleViewChange = (type) => {
    if (type === 'grid') {
      setGridView(true);
      setMapView(false);
    } else if (type === 'map') {
      setGridView(false);
      setMapView(true);
    }
  };

  // const handleSelectionForShortlist = (hotel) => {
  //   if (shortListedHotels.length > 0) {
  //     setShortListedHotels((prevItems) => {
  //       if (
  //         prevItems.some((selectedItem) => selectedItem.pbKey === hotel.pbKey)
  //       ) {
  //         return prevItems.filter(
  //           (selectedItem) => selectedItem.key !== hotel.pbKey,
  //         );
  //       }
  //       return [...prevItems, hotel];
  //     });
  //   } else {
  //     setShortListedHotels([hotel]);
  //   }
  // };
  const handleSelectionForShortlist = (hotel) => {
    if (shortListedHotels.length === 3) {
      let hotelsList = [...shortListedHotels];
      if (
        hotelsList.some(
          (shortlistedHotel) => shortlistedHotel.pbKey === hotel.pbKey,
        )
      ) {
        hotelsList = hotelsList.filter(
          (selectedHotel) => selectedHotel.pbKey !== hotel.pbKey,
        );
        setShortListedHotels(hotelsList);
        return true;
      }
      setAlert({
        variant: 'error',
        title: formattedMessage('hotel_search_title'),
        description: formattedMessage('compare_hotel_alert'),
      });
      return false;
    }
    if (shortListedHotels.length > 0) {
      setShortListedHotels((prevItems) => {
        if (
          prevItems.some((selectedItem) => selectedItem.pbKey === hotel.pbKey)
        ) {
          return prevItems.filter(
            (selectedItem) => selectedItem.pbKey !== hotel.pbKey,
          );
        }
        return [...prevItems, hotel];
      });
    } else {
      setShortListedHotels([hotel]);
    }
  };

  const handleHideEmailModal = () => {
    setShowEmailModal(false);
  };

  const handleSendEmail = async (toEmail, emailData) => {
    setShowEmailModal(false);
    setLoading(true);
    let fromEmail = '';
    let fromName = '';
    const res = await getUserDetails(getUserAgentId());
    if (res.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      fromEmail = User.ContactEmail;
      fromName = `${User.FirstName} ${User.LastName}`;
    }
    if (fromEmail !== '') {
      const emailSubject = `HOTELS in ${searchRequest.searchQuery.city} between Dates ${searchRequest.searchQuery.checkInSearch} and ${searchRequest.searchQuery.checkInSearch} for ${searchRequest.searchQuery.totalPeople} Pax`;
      const response = await emailFlightOptions(
        fromEmail,
        fromName,
        toEmail,
        emailData,
        emailSubject,
      );
      if (response && response.Root?.Status === 'OK') {
        setShortListedHotels([]);
        setAlert({
          variant: 'success',
          title: 'Email Hotel Options',
          description: 'Email Sent Successfully',
        });
      } else {
        setAlert({
          variant: 'error',
          title: 'Email Hotel Options',
          description: response?.Root?.Message || 'Failed to send Email',
        });
      }
    } else {
      setAlert({
        title: formattedMessage('user_Details'),
        description: res.ApiStatus?.Message
          ? res.ApiStatus?.Message
          : formattedMessage('failed_toload_agent_Details'),
        variant: 'error',
      });
    }
    setLoading(false);
  };

  const handleSendWhatsapp = async (whatsappNumber, msg) => {
    const encodedMessage = encodeURIComponent(msg);
    const whatsAppUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsAppUrl, '_blank');
    setShowCompareModal(false);
    setShortListedHotels([]);
    setLoading(false);
  };

  useEffect(() => {
    setVisibleHotels(searchResults.slice(0, 30));
  }, [searchResults]);

  const loadMoreHotels = () => {
    const currentCount = visibleHotels.length;
    const newHotels = searchResults.slice(currentCount, currentCount + 30);
    setVisibleHotels((prev) => [...prev, ...newHotels]);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const { scrollHeight } = document.documentElement;
      const clientHeight = window.innerHeight;
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        loadMoreHotels();
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [visibleHotels]);

  return (
    <section className="hotel-search-results-page">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {searchRequest &&
        searchRequest?.searchQuery?.checkInSearch &&
        searchRequest?.searchQuery?.checkOutSearch && (
          <>
            {!isMobileWidth() ? (
              <div ref={hotelModifyRef}>
                <div className="modify-hotel-search">
                  <div className="modify-hotel-search_container">
                    <HotelSearch previousSearchRequest={searchRequest} />
                  </div>
                </div>
                <div className="sort-hotel-results">
                  <div className="sort-hotel-results_container hide-in-mobile">
                    <div className="sort-options-container">
                      <div className="sort-header fs-16 fw-600">
                        {formattedMessage('sort_by_header')} :
                      </div>
                      <div
                        className={`${
                          sortOptionRef.current === 'priceAsc'
                            ? 'selected-sort-btn'
                            : ''
                        } sort-btn`}
                        onClick={() => handleSort('priceAsc')}
                      >
                        {formattedMessage('price_low_to_high')}
                      </div>
                      <div
                        className={`${
                          sortOptionRef.current === 'priceDec'
                            ? 'selected-sort-btn'
                            : ''
                        } sort-btn`}
                        onClick={() => handleSort('priceDec')}
                      >
                        {formattedMessage('price_high_to_low')}
                      </div>
                      <div
                        className={`${
                          sortOptionRef.current === 'starsAsc'
                            ? 'selected-sort-btn'
                            : ''
                        } sort-btn`}
                        onClick={() => handleSort('starsAsc')}
                      >
                        {formattedMessage('stars_low_to_high')}
                      </div>
                      <div
                        className={`${
                          sortOptionRef.current === 'starsDec'
                            ? 'selected-sort-btn'
                            : ''
                        } sort-btn`}
                        onClick={() => handleSort('starsDec')}
                      >
                        {formattedMessage('stars_high_to_low')}
                      </div>
                    </div>
                    <div className="align-items-center d-flex justify-content-center share-options-container">
                      <AppIconButton
                        variant={mapView ? 'primary' : 'transparent'}
                        className={mapView ? 'px-3 w-100' : 'p-0 w-100'}
                        onClick={() =>
                          handleViewChange(mapView ? 'grid' : 'map')
                        }
                      >
                        {mapView ? (
                          <div className="fs-16 fw-500">
                            {formattedMessage('grid_view_caps')}
                          </div>
                        ) : (
                          <div className="map-view-btn">
                            {/* <span>
                              <MdLocationOn />
                            </span> */}
                            <span>{formattedMessage('map_view_caps')}</span>
                          </div>
                        )}
                      </AppIconButton>
                      <AppIconButton
                        variant="white"
                        className="fs-14"
                        onClick={() => setShowInvoiceFare((prev) => !prev)}
                      >
                        {showInvoiceFare ? (
                          <IoMdEyeOff title="Net Fare" />
                        ) : (
                          <IoMdEye title="Net Fare" />
                        )}
                      </AppIconButton>
                      <AppIconButton
                        onClick={() => {
                          if (shortListedHotels.length > 0) {
                            setShowCompareModal(true);
                          } else {
                            setAlert({
                              variant: 'error',
                              title: 'Hotel Search',
                              description:
                                'Please select atleast one hotel to share',
                            });
                          }
                        }}
                        variant="transparent"
                      >
                        <MdWhatsapp />
                      </AppIconButton>
                      <AppIconButton
                        onClick={() => {
                          if (shortListedHotels.length > 0) {
                            setShowEmailModal(true);
                          } else {
                            setAlert({
                              variant: 'error',
                              title: 'Hotel Search',
                              description:
                                'Please select atleast one hotel to share',
                            });
                          }
                        }}
                        variant="transparent"
                      >
                        <MdOutlineMail />
                      </AppIconButton>
                      <AppIconButton
                        onClick={handleShowFilters}
                        variant="transparent"
                        className="show-md"
                      >
                        <MdOutlineFilterAlt />
                      </AppIconButton>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ position: 'sticky', top: '0px', zIndex: '100' }}>
                <div className="modify-hotel-search-mobile">
                  <div className="d-flex justify-content-between align-items-center white-color">
                    <div className="d-flex align-items-center">
                      <AppIconButton
                        onClick={() => navigate(-1)}
                        className="white-color"
                        variant="transparent"
                      >
                        <MdOutlineArrowBack />
                      </AppIconButton>
                      <div className="d-flex flex-column">
                        <span className="fs-10">Hotels in</span>
                        <span className="fs-16 fw-600">
                          {searchRequest.searchQuery.city},
                          <span className="fs-10 fw-600 ml-1">
                            {searchRequest.searchQuery.customerCountry}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="d-flex  align-items-center">
                      {isModifySearch ? (
                        <AppIconButton
                          className="white-color"
                          variant="transparent"
                          onClick={() => setIsModifySearch(false)}
                        >
                          <MdClose className="fs-4" />
                        </AppIconButton>
                      ) : (
                        <AppIconButton
                          className="white-color"
                          variant="transparent"
                          onClick={() => setIsModifySearch(true)}
                        >
                          <MdOutlineCreate className="fs-4" />
                        </AppIconButton>
                      )}
                      <AppIconButton
                        className="white-color"
                        variant="transparent"
                        onClick={() => setOpenFilters(true)}
                      >
                        <MdOutlineFilterAlt className="fs-4" />
                      </AppIconButton>
                    </div>
                  </div>
                  {isModifySearch && (
                    <div className="modify-hotel-search_container">
                      <HotelSearch previousSearchRequest={searchRequest} />
                    </div>
                  )}
                </div>
                <div className="sort-hotel-results">
                  <div className="sort-hotel-results_container">
                    <div className="sort-options-container">
                      <div className="sort-header fs-16 fw-600 hide-in-mobile">
                        {formattedMessage('sort_by_header')} :
                      </div>
                      <div
                        className={`${
                          sortOptionRef.current === 'priceAsc'
                            ? 'selected-sort-btn'
                            : ''
                        } sort-btn`}
                        onClick={() => handleSort('priceAsc')}
                      >
                        {formattedMessage('price_low_to_high')}
                      </div>
                      <div
                        className={`${
                          sortOptionRef.current === 'priceDec'
                            ? 'selected-sort-btn'
                            : ''
                        } sort-btn`}
                        onClick={() => handleSort('priceDec')}
                      >
                        {formattedMessage('price_high_to_low')}
                      </div>
                      <div
                        className={`${
                          sortOptionRef.current === 'starsAsc'
                            ? 'selected-sort-btn'
                            : ''
                        } sort-btn`}
                        onClick={() => handleSort('starsAsc')}
                      >
                        {formattedMessage('stars_low_to_high')}
                      </div>
                      <div
                        className={`${
                          sortOptionRef.current === 'starsDec'
                            ? 'selected-sort-btn'
                            : ''
                        } sort-btn`}
                        onClick={() => handleSort('starsDec')}
                      >
                        {formattedMessage('stars_high_to_low')}
                      </div>
                    </div>
                    {searchResults.length > 0 && (
                      <div className="share-options-container d-flex align-items-center">
                        <div className="flex-1 hotel-search-results-page__sort-container">
                          <AppIconButton
                            variant={mapView ? 'primary' : 'transparent'}
                            className={mapView ? 'px-3 w-100' : 'p-0 w-100'}
                            onClick={() =>
                              handleViewChange(mapView ? 'grid' : 'map')
                            }
                          >
                            {mapView ? (
                              <div className="fs-16 fw-500">
                                {formattedMessage('grid_view_caps')}
                              </div>
                            ) : (
                              <div className="map-view-btn">
                                <span>
                                  <MdLocationOn />
                                </span>
                                <span>{formattedMessage('map_view_caps')}</span>
                              </div>
                            )}
                          </AppIconButton>
                        </div>
                        <div className="d-flex  align-items-center">
                          <AppIconButton
                            className=""
                            variant="transparent"
                            onClick={() => setShowShareOptions((prev) => !prev)}
                          >
                            {showShareOptions ? (
                              <MdClose />
                            ) : (
                              <MdOutlineShare />
                            )}
                          </AppIconButton>
                          {showShareOptions && (
                            <div className="d-flex align-items-center justify-content-center">
                              <AppIconButton
                                variant="transparent"
                                onClick={() => {
                                  if (shortListedHotels.length > 0) {
                                    setShowEmailModal(true);
                                  } else {
                                    setAlert({
                                      variant: 'error',
                                      title: 'Hotel Search',
                                      description:
                                        'Please select atleast one hotel to share',
                                    });
                                  }
                                }}
                              >
                                <MdOutlineMail className=" fs-4" />
                              </AppIconButton>
                              <AppIconButton
                                variant="transparent"
                                onClick={() => {
                                  if (shortListedHotels.length > 0) {
                                    setShowCompareModal(true);
                                  } else {
                                    setAlert({
                                      variant: 'error',
                                      title: 'Hotel Search',
                                      description:
                                        'Please select atleast one hotel to share',
                                    });
                                  }
                                }}
                              >
                                <MdWhatsapp className=" fs-4" />
                              </AppIconButton>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      {searchProgress > 0 && (
        <div className="hsr-progress-bar-wrap">
          <div className="hsr-progress-bar-track">
            <div
              className="hsr-progress-bar-fill"
              style={{ width: `${searchProgress}%` }}
            />
          </div>
          <span
            className="hsr-progress-bar-label"
            style={{ left: `${searchProgress}%` }}
          >
            {searchProgress}%
          </span>
        </div>
      )}
      {isPreviewLoading && <AppPreviewLoader service="hotel" />}
      {searchRequest &&
        searchRequest?.searchQuery?.checkInSearch &&
        searchRequest?.searchQuery?.checkOutSearch && (
          <div className="hotel-search-results-container pt-3">
            {isSearchDone && allSearchResultsRef.current.length > 0 ? (
              <Row className="spacing-8">
                {hotelNames.length > 0 && hotelLocations.length > 0 && (
                  <Col
                    lg={3}
                    className="display-md-none " //
                    style={{ top: `${hotelModifyDivHeight + 70}px` }}
                  >
                    <HotelFilter
                      minPrice={minHotelFare}
                      maxPrice={maxHotelFare}
                      selectedFilters={selectedFilters}
                      onApplyFilter={handleApplyFilter}
                      onClearFilters={handleapplyClearFilter}
                      onCloseMobile={() => setOpenFilters(false)}
                      amenitiesList={amenitiesList}
                      currencyOption={currencyOption}
                      conversionRate={conversionRate}
                      hotelNames={hotelNames}
                      hotelLocations={hotelLocations}
                      starCount={starCount}
                      facilities={facilities}
                      propertyTypes={propertyTypes}
                    />
                  </Col>
                )}
                {searchResults.length > 0 ? (
                  <Col
                    lg={9}
                    md={12}
                    sm={12}
                    xs={12}
                    className="margin-for-hotel-results-card"
                  >
                    {isSearchDone && (
                      <div className="d-flex flex-column p-2">
                        <div className="fs-12 fw-500 me-2 hotels-found-text">
                          {hotelCount} Hotel{hotelCount > 1 ? 's' : ''} Found
                        </div>
                        {isCacheLoading && (
                          <span className="hsr-sort-bar__loading-badge">
                            <span className="hsr-sort-bar__loading-dot" />
                            <span className="hsr-sort-bar__loading-dot" />
                            <span className="hsr-sort-bar__loading-dot" />
                            Loading more hotels
                          </span>
                        )}
                      </div>
                    )}
                    <div className="px-sm-0 px-2">
                      {gridView &&
                        visibleHotels.map((d, index) => (
                          <HotelCardV2
                            key={d.pbKey || d.key || index}
                            hotelData={d}
                            onRoomChoose={onRoomChoose}
                            showInvoiceFare={showInvoiceFare}
                            currencyOption={currencyOption}
                            conversionRate={conversionRate}
                            onShortList={handleSelectionForShortlist}
                            shortListedHotels={shortListedHotels}
                            intl={intl}
                            index={index}
                          />
                        ))}
                      {mapView && (
                        <HotelMapOldView
                          hotelDetails={searchResults}
                          onRoomChoose={onRoomChoose}
                          showInvoiceFare={showInvoiceFare}
                          currencyOption={currencyOption}
                          conversionRate={conversionRate}
                          onShortList={handleSelectionForShortlist}
                          shortListedHotels={shortListedHotels}
                        />
                      )}
                      {isLoadingMoreHotels && (
                        <div className="infinate-scroll-loader d-flex justify-content-center align-items-center py-3 ">
                          <div className="dots-container d-flex align-items-center">
                            <div className="fs-12">Loading More Hotels</div>
                            <div className="dot" />
                            <div className="dot" />
                            <div className="dot" />
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                ) : (
                  <Col
                    lg={9}
                    md={12}
                    sm={12}
                    xs={12}
                    className="margin-for-hotel-results-card"
                  >
                    {isSearchDone && (
                      <NoSearchResults
                        title={formattedMessage('no_hotel_found')}
                      >
                        <FaHotel style={{ transform: 'rotate(-90deg)' }} />
                      </NoSearchResults>
                    )}
                  </Col>
                )}
              </Row>
            ) : (
              isSearchDone &&
              allSearchResultsRef.current.length === 0 && (
                <NoSearchResults title={formattedMessage('no_hotel_found')}>
                  <FaHotel style={{ transform: 'rotate(-90deg)' }} />
                </NoSearchResults>
              )
            )}
          </div>
        )}

      {openFilters && (
        <AppSidebar
          sidebarTitle={formattedMessage('filter_btn')}
          showActions
          animatedClass="slide-from-right-animation"
          onHideSidebar={() => setOpenFilters(false)}
          className="p-0"
        >
          <HotelFilter
            minPrice={minHotelFare}
            maxPrice={maxHotelFare}
            selectedFilters={selectedFilters}
            onApplyFilter={handleApplyFilter}
            onClearFilters={handleapplyClearFilter}
            onCloseMobile={() => setOpenFilters(false)}
            amenitiesList={amenitiesList}
            currencyOption={currencyOption}
            conversionRate={conversionRate}
            hotelNames={hotelNames}
            hotelLocations={hotelLocations}
            starCount={starCount}
            facilities={facilities}
            propertyTypes={propertyTypes}
          />
        </AppSidebar>
      )}
      {shortListedHotels.length > 0 && showCompareModal && (
        <AppModal
          modalTitle="Send WhatsApp"
          showCloseButton
          showFooter={false}
          size="lg"
          onModalClose={() => setShowCompareModal(false)}
        >
          <HotelWhatsAppShareModal
            onSend={handleSendWhatsapp}
            shortListedHotels={shortListedHotels}
            searchRequest={searchRequest}
          />
        </AppModal>
      )}
      {showEmailModal && shortListedHotels.length > 0 && (
        <AppModal
          size="lg"
          showCloseButton
          onModalClose={handleHideEmailModal}
          modalTitle={formattedMessage('send_email_btn')}
        >
          <HotelEmailShareModal
            onSend={handleSendEmail}
            shortListedHotels={shortListedHotels}
            searchRequest={searchRequest}
          />
        </AppModal>
      )}
    </section>
  );
}

HotelSearchResults.defaultProps = {};

HotelSearchResults.propTypes = {};

export default HotelSearchResults;
